import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Label } from 'components';
import AutocompleteField from 'components/AutocompleteField/AutocompleteField';
import { IOptions } from 'components/Select/Select.types';
import AnalystService from 'services/ApiService/AnalystService';
import { toast } from 'react-toastify';
import { IAnalyst } from 'services/ApiService/AnalystService';
import { ISelectAnalystProps } from './SelectAnalyst.types';

export const SelectAnalyst = ({ analystSelected, setAnalystSelected, companies }: ISelectAnalystProps) => {
  const [analystsList, setAnalystsList] = useState<IOptions[]>([]);
  const companiesRef = useRef(['']);

  const handleChangeAnalyst = (value: IOptions) => {
    return value ? setAnalystSelected(value) : setAnalystSelected({ name: '', value: '' });
  };

  const analystsToOptions = (analysts: IAnalyst[]): IOptions[] => {
    return analysts.map(({ id: value, username: name }) => ({ value, name }));
  };

  const getAnalysts = useCallback(async (companiesIds: string[]): Promise<IOptions[]> => {
    try {
      const analysts = await AnalystService.getAnalysts(companiesIds);
      return analystsToOptions(analysts);
    } catch (error) {
      toast.error('Problema ao carregar os analistas, tente novamente.');

      return [];
    }
  }, []);

  const handleAnalysts = useCallback(async (): Promise<void> => {
    const analysts = await getAnalysts(companies);
    setAnalystsList(analysts);
  }, [companies, getAnalysts]);

  const companiesChanged = useCallback(() => {
    return companiesRef.current[0] !== companies[0] && companies.length > 0;
  }, [companies]);

  useEffect(() => {
    if (companiesChanged()) {
      companiesRef.current = companies;
      setAnalystSelected({ name: '', value: '' });
      handleAnalysts();
    }
  }, [handleAnalysts, companies, companiesChanged, setAnalystSelected]);

  return (
    <>
      {analystsList.length > 0 && (
        <>
          <Label htmlFor="analyst" testID="label-analyst">
            Analista - Opcional
          </Label>

          <AutocompleteField
            required={false}
            testID="select-analyst"
            id="analyst"
            options={analystsList}
            selected={analystSelected.name}
            placeholder="Insira o analista"
            onChange={(e: React.SyntheticEvent<Element, Event>, value: IOptions) => handleChangeAnalyst(value)}
          />
        </>
      )}
    </>
  );
};
